import { Content } from './Content';
import { Menu } from './Menu';
import { Select } from './Menu/Select';
import { InstrumentSchema } from '../../types/common';
import { CardInstrumentId, supports } from './consts';

const schema: InstrumentSchema<CardInstrumentId> = {
  supports: new Set(supports),
  components: { Content, Menu, Select },
};

export default schema;
